import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IPayPalConfig, ICreateOrderRequest } from 'ngx-paypal';
import { ApiService } from 'src/app/shared/services/api.service';
import { CartService } from 'src/app/shared/services/cart.service';
import { lastValueFrom, Subscription, throwError } from 'rxjs';
import {render} from 'creditcardpayments/creditCardPayments';

@Component({
  selector: 'molla-paypal',
  templateUrl: './paypal.component.html',
  styleUrls: ['./paypal.component.scss']
})
export class PaypalComponent{

  constructor(public  apiService:ApiService, public cartService:CartService, public router:Router){

  }

  public payPalConfig?: IPayPalConfig;
  amount:any;
  cartItems = [];
  private subscr: Subscription;


  async ngOnInit(): Promise<void> {    
    try {
      this.subscr = this.cartService.cartStream.subscribe(items => {
        this.cartItems = items;
      });   
      let total = this.cartService.priceTotal['_value'];
      this.amount = String(Number(total)+this.apiService.shippingCost  - this.apiService.redeemPoints);
      render({
        id:"#paypalButtons",
        currency:"EUR",
        value:this.amount,
        onApprove:(details) =>{
          this.placeOrderClicked(event,details);        
        },            
      });      
    } catch (error) {
      await this.apiService.logError(error, this.router.url);
    }
    
  }

  ngOnLoad():void{
    
  }



  private initConfig(): void {
   this.payPalConfig = {    
    currency: 'EUR',
    clientId: this.apiService.paypal_auth,//'ATP05E4qfSilhruMfdbgOuhhHk75DEGGO_SPDiHWerLFntqtVdhdcuJNVs6SEyxrVZ0SvFxFrkOnzrqr',    
    createOrderOnClient: (data) => <ICreateOrderRequest>{
      intent: 'CAPTURE',
      purchase_units: [
        {
          amount: {
            currency_code: 'EUR',
            value: this.amount, //'9.99',
            breakdown: {
              item_total: {
                currency_code: 'EUR',
                value: this.amount//'9.99'
              }
            }
          },
          items: [
            {
              name: this.apiService.company_name,
              quantity: '1',
              category: 'DIGITAL_GOODS',
              unit_amount: {
                currency_code: 'EUR',
                value: this.amount,//'9.99',
              },
            }
          ]
        }
      ]
    },
    advanced: {
      commit: 'true'
    },
    style: {
      label: 'paypal',
      layout: 'vertical'
    },
    onApprove: (data, actions) => {
      //console.log('onApprove - transaction was approved, but not authorized', data, actions);
      actions.order.get().then(details => {
        //console.log('onApprove - you can get full order details inside onApprove: ', details);        
      });
    },
    onClientAuthorization: (data) => {
      //console.log('onClientAuthorization - you should probably inform your server about completed transaction at this point', data);      
      //this.success(data);      
      //this.showSuccess = true;
      this.placeOrderClicked(event,data);
      //console.log(data);
    },
    onCancel: (data, actions) => {
      //console.log('OnCancel', data, actions);
    },
    onError: err => {
      this.apiService.popupMsg('Something went wrong!','Try again or contact us.','error');
      //console.log('OnError', err);
    },
    onClick: (data, actions) => {      
      let total = this.cartService.priceTotal['_value'];
		  this.amount = String(Number(total)+this.apiService.shippingCost - this.apiService.redeemPoints);
      //console.log('onClick', data, actions, this.amount);
    }
   };
  }

  success(data:any){
    /* this.apiService.popupMsg('Success!','Your paymnet has been completed successfully','success');
    this.router.navigate(['/']);
				//clear cart
				this.cartItems.forEach(item =>{
					this.cartService.removeFromCart(item);
				})			     */

  }

  async placeOrderClicked(event:any,payment:any){
    try {
        event.preventDefault();
      let notes = (<HTMLInputElement>document.getElementById("orderNotes")).value;
      if(this.apiService.userInfo.length == 0){
        this.apiService.popupMsg("Login first!","Please login to checkout","info");			
      }
      else{
        //this.calcVAT(this.apiService.userInfo[0]["CUSTVAT"]);
        let res = await lastValueFrom(this.apiService.saveOrderPromise(this.cartItems, this.cartService.priceTotal['_value'], notes, "Paypal Id: " + payment.id));
        if(res != "success")
        {
          this.apiService.popupMsg("Something went wrong!","Order not saved.","error");
        }
        else{   
          await lastValueFrom(this.apiService.sendEmailCompany(this.cartItems));   
          await lastValueFrom(this.apiService.sendCustomerConfirmationEmail(this.cartItems));  
          this.apiService.popupMsg("Congrats!","Completed successfully","info");
          this.router.navigate(['/']);
          //clear cart
          this.cartItems.forEach(item =>{
            this.cartService.removeFromCart(item);
          })				
        }
      }		    
    } catch (error) {
      await this.apiService.logError(error, this.router.url);
    }
		
	}

	async checkStockBeforePay(){
    /**
     * check if items are in stock and abort payment if neccessary
    */			
    for(let i=0; i<this.cartItems.length;i++){
      let res:any = await this.apiService.getSingleProductPromise(this.cartItems[i].id)
      if(this.cartItems[i].qty > res.product.stock ){										
        this.apiService.popupMsg("Out of Stock!\n"+this.cartItems[i].name,"Available stock: "+res.product.stock,"error");
        return true;						
      }
    }		
    return false;
  }

}
